export const EmptySitesImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="374"
      height="326"
      viewBox="0 0 374 326"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        d="M115.534 151.35H273.522V195.395H115.534L115.534 151.35Z"
        fill="#2164DA"
      />
      <path
        d="M31.768 87.0186L45.339 67.4461L106.691 112.369C106.691 112.369 147.631 77.4813 167.239 64.1141C173.186 60.0608 169.156 109.245 169.156 109.245L136.432 133.522C119.269 144.717 96.7671 143.196 81.2658 129.794L31.768 87.0186Z"
        fill="#EBA687"
        stroke="#272D41"
      />
      <path
        d="M32.0581 71.809L6.67999 69.312C5.3895 69.188 4.44272 68.0431 4.56319 66.7522C4.66019 65.5422 5.66217 64.6047 6.87599 64.5884L31.7876 64.463L32.0581 71.809Z"
        fill="#EBA687"
      />
      <path
        d="M26.4172 71.2485L6.67999 69.312C5.3895 69.188 4.44272 68.0431 4.56319 66.7522C4.66019 65.5422 5.66217 64.6047 6.87599 64.5884L31.7876 64.463"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M30.839 77.199L3.00696 75.3566C2.38346 75.3193 1.80041 75.0355 1.38639 74.5678C0.97238 74.1001 0.761406 73.4869 0.8 72.8635C0.861514 71.652 1.83428 70.686 3.04616 70.633L30.3254 69.849L30.839 77.199Z"
        fill="#EBA687"
      />
      <path
        d="M26.6446 76.9207L3.00304 75.3527C1.70771 75.2729 0.721836 74.159 0.799999 72.8635C0.861513 71.652 1.83428 70.6861 3.04616 70.633L26.3584 69.9588"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M32.0267 83.671L6.62903 81.2759C5.33549 81.1578 4.38252 80.0136 4.50047 78.72C4.5932 77.5113 5.58945 76.5711 6.80151 76.5483L31.7131 76.3053L32.0267 83.671Z"
        fill="#EBA687"
      />
      <path
        d="M26.9229 82.4322L6.62905 81.2562C5.34384 81.138 4.39397 80.0062 4.50049 78.72C4.59322 77.5113 5.58947 76.571 6.80153 76.5483L26.4721 76.368"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M40.1098 87.1362L14.6062 86.5365C13.9824 86.5251 13.3887 86.2664 12.9556 85.8172C12.5226 85.368 12.2858 84.7652 12.2974 84.1413C12.3049 82.927 13.2357 81.9181 14.4455 81.8129L39.2748 79.8137L40.1098 87.1362Z"
        fill="#EBA687"
      />
      <path
        d="M48.2634 64.1298L59.357 87.8497L31.6818 87.0657C31.6818 87.0657 28.8359 80.9348 28.8319 75.5213C28.4831 71.0525 30.0942 64.8902 30.0942 64.8902L48.2634 64.1298Z"
        fill="#EBA687"
      />
      <path
        d="M30.0942 64.8785C30.0942 64.8785 26.7935 74.4942 30.7919 84.7999"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M59.357 87.8496L41.8189 65.3253L26.8053 64.5021C24.4807 64.3532 22.6932 62.1501 22.7677 59.4806L22.8147 57.9126L41.6307 58.0145C46.5163 58.0441 51.1836 60.0421 54.5772 63.5568C57.9709 67.0714 59.8042 71.8058 59.6627 76.6894L59.357 87.8496Z"
        fill="#EBA687"
      />
      <path
        d="M22.8147 57.9048L22.7677 59.4728C22.6932 62.1227 24.4807 64.3453 26.8053 64.4943L37.256 65.0862C37.256 65.0862 38.3732 75.9446 45.6095 79.0179"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M35.2215 87.344L14.6062 86.56C13.9824 86.5486 13.3887 86.2899 12.9556 85.8407C12.5226 85.3915 12.2858 84.7887 12.2974 84.1649C12.3049 82.9505 13.2357 81.9416 14.4455 81.8364L26.9895 80.825"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M26.8053 64.5021C24.4807 64.3532 22.6932 62.1501 22.7677 59.4806L22.8147 57.9126L41.6307 58.0145C46.5163 58.0441 51.1836 60.0421 54.5772 63.5568C57.9709 67.0714 59.8042 71.8058 59.6627 76.6894L59.357 83.424"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M174.252 59.7276C162.884 65.5684 137.659 86.317 121.854 99.7116L147.584 125.442L147.925 137.144L173.217 109.864C173.217 109.864 183.562 72.5852 182.026 60.9898C181.665 58.2576 175.471 59.12 174.252 59.7276Z"
        fill="white"
      />
      <path
        d="M173.217 109.864L147.925 137.128L147.584 125.427L121.854 99.6959C135.966 87.736 157.6 69.9039 170.152 62.0639C172.57 60.5561 175.247 59.5113 178.047 58.9828"
        stroke="#272D41"
      />
      <path
        d="M134.511 134.643L136.887 137.022C139.98 139.994 144.883 139.945 147.917 136.912C150.951 133.878 151 128.975 148.027 125.881L147.584 125.442L137.835 132.667C136.751 133.378 135.643 134.036 134.511 134.643H134.511Z"
        fill="#272D41"
        stroke="#272D41"
      />
      <path
        d="M340.801 85.5996L327.23 66.027L265.878 110.95C265.878 110.95 225.784 74.9136 201.065 62.1266C194.671 58.8181 203.417 107.822 203.417 107.822L236.172 132.099C253.333 143.295 275.834 141.776 291.335 128.375L340.801 85.5996Z"
        fill="#EBA687"
        stroke="#272D41"
      />
      <path
        d="M341.942 71.2406L367.32 68.724C368.61 68.5999 369.557 67.455 369.437 66.1642C369.34 64.9542 368.338 64.0167 367.124 64.0004L342.232 63.8749L341.942 71.2406Z"
        fill="#EBA687"
      />
      <path
        d="M347.583 70.6801L367.328 68.7201C368.618 68.596 369.565 67.4511 369.445 66.1603C369.348 64.9502 368.346 64.0128 367.132 63.9965L342.232 63.8749"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M343.161 76.6306L370.993 74.7882C372.288 74.7064 373.273 73.5906 373.192 72.2951C373.131 71.0836 372.158 70.1177 370.946 70.0646L343.667 69.2806L343.161 76.6306Z"
        fill="#EBA687"
      />
      <path
        d="M347.355 76.368L370.997 74.8C372.292 74.7181 373.277 73.6024 373.196 72.3069C373.135 71.0954 372.162 70.1294 370.95 70.0764L347.638 69.4022"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M341.973 83.1025L367.371 80.7074C368.663 80.5894 369.615 79.4476 369.5 78.1555C369.407 76.9468 368.411 76.0065 367.198 75.9838L342.287 75.7408L341.973 83.1025Z"
        fill="#EBA687"
      />
      <path
        d="M347.077 81.856L367.371 80.6996C368.663 80.5815 369.615 79.4398 369.5 78.1477C369.407 76.939 368.411 75.9987 367.199 75.976L347.528 75.7839"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M333.89 86.56L359.394 85.9602C360.018 85.9489 360.611 85.6902 361.044 85.241C361.477 84.7918 361.714 84.1889 361.703 83.5651C361.695 82.3508 360.764 81.3418 359.554 81.2366L334.725 79.2374L333.89 86.56Z"
        fill="#EBA687"
      />
      <path
        d="M325.737 63.5613L314.643 87.2813L342.318 86.4973C342.318 86.4973 345.164 80.3664 345.168 74.9529C345.517 70.4841 343.906 64.3257 343.906 64.3257L325.737 63.5613Z"
        fill="#EBA687"
      />
      <path
        d="M343.906 64.314C343.906 64.314 347.206 73.9258 343.208 84.2315"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M314.643 87.2813L332.181 64.757L347.195 63.9338C349.519 63.7848 351.307 61.5622 351.232 58.9122L351.185 57.3442L332.369 57.4462C327.484 57.4758 322.816 59.4738 319.423 62.9884C316.029 66.5031 314.196 71.2374 314.337 76.121L314.643 87.2813Z"
        fill="#EBA687"
      />
      <path
        d="M351.185 57.3364L351.232 58.9044C351.307 61.5543 349.519 63.7769 347.195 63.9259L336.744 64.5178C336.744 64.5178 335.627 75.3762 328.39 78.4495"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M338.778 86.756L359.394 85.972C360.018 85.9606 360.611 85.7019 361.044 85.2527C361.477 84.8035 361.714 84.2007 361.703 83.5768C361.695 82.3625 360.764 81.3536 359.554 81.2484L347.01 80.237"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M347.195 63.9338C349.519 63.7848 351.307 61.5622 351.232 58.9122L351.185 57.3442L332.369 57.4462C327.484 57.4758 322.816 59.4738 319.423 62.9884C316.029 66.5031 314.196 71.2374 314.337 76.121L314.659 82.8752"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M201.633 60.4215C213.001 66.2623 236.341 85.7486 252.146 99.1432L226.416 124.874L226.075 136.575L200.783 109.296C200.783 109.296 189.807 71.2995 191.971 60.4215C192.449 58.0107 200.469 59.8217 201.633 60.4215Z"
        fill="white"
      />
      <path
        d="M226.075 136.575L226.416 124.874L252.146 99.1432C238.364 87.4616 217.411 70.194 204.746 62.0914C201.773 60.1847 198.342 59.1136 194.813 58.9907"
        stroke="#272D41"
      />
      <path
        d="M239.489 134.074L237.113 136.454C234.02 139.426 229.117 139.377 226.083 136.343C223.049 133.31 223 128.407 225.973 125.313L226.416 124.874L236.165 132.099C237.252 132.809 238.36 133.468 239.489 134.074Z"
        fill="#272D41"
        stroke="#272D41"
      />
      <path
        d="M172.363 143.11H274.675C292.577 143.11 303.291 154.803 306.74 166.842C314.008 192.247 297.987 220.695 265.62 223.094L257.125 223.642C235.957 224.058 208.952 250.51 193.958 250.236L195.663 233.47L194.244 186.869L266.576 180.687"
        fill="#2164DA"
      />
      <path
        d="M172.363 143.11H274.675C292.577 143.11 303.291 154.803 306.74 166.842C314.008 192.247 297.987 220.695 265.62 223.094L257.125 223.642C235.957 224.058 208.952 250.51 193.958 250.236L195.663 233.47L194.244 186.869L266.576 180.687"
        stroke="#272D41"
      />
      <path
        d="M201.065 241.569C201.064 243.945 200.118 246.224 198.436 247.903C196.753 249.581 194.473 250.522 192.096 250.518C187.153 250.518 183.147 246.511 183.147 241.569V223.199C187.686 223.337 193.789 223.497 201.049 223.631L201.065 241.569Z"
        fill="#272D41"
        stroke="#272D41"
      />
      <path
        d="M183.162 187.696L194.244 186.873L201.065 223.635C193.805 223.501 187.702 223.341 183.162 223.203H182.994C177.61 223.04 172.575 225.857 169.897 230.53L167.231 243.137C165.457 251.516 159.746 258.524 151.896 261.953L149.709 200.993C149.496 195.135 153.923 190.144 159.764 189.656L183.162 187.696Z"
        fill="#EBA687"
        stroke="#272D41"
      />
      <path
        d="M221.665 143.11H155.742L161.52 81.3111C162.763 68.0223 174.66 58.7162 188.004 58.7162L189.14 58.9985C202.033 58.9985 211.073 67.3638 212.86 80.1273L221.665 143.11Z"
        fill="white"
      />
      <path
        d="M212.848 80.1312L221.665 143.11H155.742L161.508 81.3111"
        stroke="#272D41"
      />
      <path
        d="M212.147 143.11H109.835C91.9322 143.11 81.2188 154.803 77.7653 166.842C70.4702 192.247 86.5069 220.695 118.874 223.094L127.369 223.642C148.537 224.058 175.542 250.51 190.536 250.236L188.831 233.47L183.445 186.191L117.922 180.703"
        fill="#2164DA"
      />
      <path
        d="M212.147 143.11H109.835C91.9322 143.11 81.2188 154.803 77.7653 166.842C70.4702 192.247 86.5069 220.695 118.874 223.094L127.369 223.642C148.537 224.058 175.542 250.51 190.536 250.236L188.831 233.47L183.445 186.191L117.922 180.703"
        stroke="#272D41"
      />
      <path
        d="M183.445 241.569C183.447 246.512 187.455 250.518 192.398 250.518C197.34 250.518 201.347 246.511 201.347 241.569V223.199C196.808 223.337 190.7 223.497 183.445 223.631V241.569Z"
        fill="#272D41"
        stroke="#272D41"
      />
      <path
        d="M201.347 187.696L183.445 186.195V223.634C190.7 223.501 196.808 223.34 201.347 223.203H201.504C206.887 223.04 211.923 225.857 214.601 230.53L217.266 243.136C219.041 251.516 224.752 258.524 232.601 261.952L234.789 200.993C235.002 195.139 230.582 190.15 224.746 189.656L201.347 187.696Z"
        fill="#EBA687"
        stroke="#272D41"
      />
      <path d="M188.701 143.11V187.28V143.11Z" fill="#EBA687" />
      <path d="M188.701 143.11V187.28" stroke="#272D41" />
      <path
        d="M180.614 143.11V163.341C180.614 167.383 182.655 171.152 186.04 173.361L188.701 175.097"
        stroke="#272D41"
      />
      <path d="M219.803 129.809L226.071 136.575" stroke="#272D41" />
      <path
        d="M172.363 69.2297C172.363 72.8473 173.8 76.3167 176.358 78.8744C178.917 81.432 182.387 82.8684 186.004 82.8674C193.536 82.8674 199.642 76.7616 199.642 69.2297V59.8217C197.772 59.3866 195.103 58.9985 193.448 59.3395C192.022 59.1143 190.58 59.0016 189.136 59.0024L188 58.7202C185.62 58.7206 183.249 59.0195 180.944 59.61C179.023 58.6496 175.189 59.2494 174.28 59.7315C173.688 60.0334 173.057 60.3822 172.39 60.7625L172.363 69.2297Z"
        fill="#EBA687"
        stroke="#272D41"
      />
      <path
        d="M160.861 16.2156C160.861 16.2156 155.597 32.856 171.512 36.8348C178.047 35.4157 171.226 20.0689 171.226 20.0689L160.861 16.2156Z"
        fill="#272D41"
        stroke="#272D41"
      />
      <path
        d="M178.333 67.2383V35.698"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M192.539 35.4158L194.813 61.2721L178.329 67.2423V35.698"
        fill="#EBA687"
      />
      <path
        d="M192.539 35.4158L194.813 61.2721"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M178.333 46.38C178.333 46.38 182.594 46.772 185.718 44.7924C184.868 49.6218 178.333 55.1686 178.333 55.1686V46.38Z"
        fill="#272D41"
        stroke="#272D41"
      />
      <circle cx="181.316" cy="35.5569" r="11.223" fill="#EBA687" />
      <path
        d="M185.718 45.8821C181.532 47.6521 176.691 46.7221 173.458 43.5268C170.226 40.3315 169.239 35.5019 170.961 31.2951C172.682 27.0883 176.771 24.335 181.316 24.3221"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M193.39 44.5062C193.39 44.5062 187.423 44.5062 187.141 36.8348C190.834 35.4157 189.129 30.0179 186.573 30.8685C184.017 31.7192 184.299 37.6893 184.299 37.6893C184.299 37.6893 182.026 34.5533 182.594 28.8811H168.995C166.723 28.8811 164.544 27.9782 162.938 26.371C161.331 24.7639 160.429 22.5843 160.43 20.312C160.429 15.1224 162.49 10.1451 166.159 6.47511C169.828 2.80516 174.805 0.743347 179.995 0.743347C195.087 0.743347 206.259 14.9141 202.582 29.5553C201.214 35.0277 198.446 40.3354 193.39 44.5062Z"
        fill="#AA90FA"
        stroke="#272D41"
      />
      <path d="M178.333 46.38V68.0929" stroke="#272D41" strokeLinecap="round" />
      <path
        d="M188.701 163.416H269.92C278.816 163.416 286.027 170.627 286.027 179.523C286.027 186.593 281.416 192.836 274.659 194.917L234.573 207.265"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <path
        d="M180.603 163.416H110.827C106.614 163.416 102.574 165.089 99.595 168.068C96.6162 171.047 94.9427 175.087 94.9427 179.299C94.9444 186.457 99.7348 192.729 106.64 194.615L183.162 215.567"
        stroke="#272D41"
        strokeLinecap="round"
      />
      <ellipse
        cx="192.253"
        cy="315.59"
        rx="116.22"
        ry="9.6628"
        fill="#272D41"
        stroke="#272D41"
      />
    </svg>
  )
}
